import { useSetAtom } from 'jotai';
import { PanelSection, PointOfInterest } from '@/__generated__/graphql';
import { AllPointOfInterestTemplate, PoiFormState } from '@/types';
import * as poiState from '../../../state';
import { BLISTER_TYPE, PIT_TYPE } from '@/constants';
import * as state from '@/components/Analysis/state';

type Props = {
  pointOfInterest?: PointOfInterest;
  formState: PoiFormState;
  template?: AllPointOfInterestTemplate[0];
  editingSection?: PanelSection;
};

export const useTriggerPoiEditing = () => {
  const setEditPointOfInterest = useSetAtom(poiState.editPointOfInterest);
  const setBlisterToAdd = useSetAtom(poiState.blisterToAdd);
  const setBlisterPolys = useSetAtom(poiState.blisterPolygons);
  const setDrawerRight = useSetAtom(state.drawerRight);

  const triggerEdit = ({ formState, pointOfInterest, template, editingSection }: Props) => {
    setEditPointOfInterest((previous) => ({
      ...previous,
      pointOfInterest,
      formState,
      state: 'WaitingForDetail',
      template,
      editingSection,
    }));

    if (pointOfInterest?.type === BLISTER_TYPE || pointOfInterest?.type === PIT_TYPE) {
      setBlisterToAdd({ state: 'UpdatingBlister' });
      setBlisterPolys((previous) => {
        if (!previous) return undefined;
        return previous.map((item) =>
          item.id && pointOfInterest.id && item.id.startsWith(pointOfInterest.id)
            ? { ...item, isVisible: true }
            : item
        );
      });
    }
  };

  const cancelEditing = () => {
    setBlisterToAdd(undefined);
    setEditPointOfInterest((previous) => ({
      ...previous,
      pointOfInterest: undefined,
      formState: undefined,
      state: 'Inactive',
      editingSection: undefined,
    }));
    // we open right drawer here
    setDrawerRight({
      equipment: true,
      viewpoints: false,
      measuringTool: false,
      findViewpointsTool: false,
    });
  };

  return { triggerEdit, cancelEditing };
};
